import Row from '@components/Row';
import Text from '@components/Text';
import colors from '@constants/colors';
import { css } from '@emotion/react';
import useUser from '@hooks/auth/useUser';
import ArrowLineRight from '@icons/arrow/ArrowLineRight';
import { Link } from '@stackflow/link';
import { useTranslation } from 'react-i18next';

function UserInfo() {
    const { t } = useTranslation('main', { keyPrefix: 'sidebar' });
    const { user } = useUser();

    if (user) {
        return (
            <Text fontWeight='bold' size='display' color={colors.textPrimary} css={css`
                    white-space: wrap;
                    word-break: break-all;
                `}>
                {t('userName', {
                    name: user?.nickname
                        || user?.identityInfo?.name
                        || t('defaultName'),
                })}
            </Text>
        );
    }
    return (<Link activityName='SignInActivity'
        activityParams={{}}>
        <Row spacing={2}>
            <Text size='display' fontWeight='bold' color={colors.textPrimary}>{t('login')}</Text>
            <ArrowLineRight size={16} color='var(--color-icon-default)'/>
        </Row>
    </Link>);
}

export default UserInfo;
